import { render } from "./all-check.vue?vue&type=template&id=1445f7e4"
import script from "./all-check.vue?vue&type=script&lang=js"
export * from "./all-check.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__